export default __webpack_public_path__ + "static/media/camion_scania_negro.6a8e5ade.png";